module.exports = "<a href=# class=\"base-btn purple-btn v2-btn modal-auto-hide cancel-btn\">Close</a><a href=# class=\"base-btn purple-btn modal-auto-hide packingPrdExportDataModal\">Export</a>";


//////////////////
// WEBPACK FOOTER
// ./src/pages/asns/detailPageLookupHTML/modalFooterForPackingDetail.html
// module id = 1236
// module chunks = 1